import axiosInstance from '@/api/axiosInstance';
import { GetModuleContentBlocksResponse } from './types';

/**
 * Fetch content blocks for a specific module
 * GET /api/learning-center/modules/{moduleId}/content-blocks
 *
 * @param moduleId - The ID of the module
 * @returns Promise with content blocks array
 * @throws Error if module not found (404) or request fails
 */
export const getModuleContentBlocks = async (
  moduleId: number
): Promise<GetModuleContentBlocksResponse> => {
  try {
    const response = await axiosInstance.get<GetModuleContentBlocksResponse>(
      `/api/learning-center/modules/${moduleId}/content-blocks`
    );
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      console.error(`Module with ID ${moduleId} not found`);
      throw new Error(`Module with ID ${moduleId} not found`);
    }
    console.error('Error fetching module content blocks:', error);
    throw error;
  }
};
